import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container, Menu, MenuItem } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import StickyFooter from '../StickyFooter';
import logo from '../assets/images/st.png';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#f8f9fb',
    },
  },
});

const Layout = ({ children }) => {
  const location = useLocation();
  const [servicesAnchorEl, setServicesAnchorEl] = useState(null);
  const [industriesAnchorEl, setIndustriesAnchorEl] = useState(null);
  const openServices = Boolean(servicesAnchorEl);
  const openIndustries = Boolean(industriesAnchorEl);

  const handleServicesClick = (event) => {
    setServicesAnchorEl(event.currentTarget);
  };

  const handleServicesClose = () => {
    setServicesAnchorEl(null);
  };

  const handleIndustriesClick = (event) => {
    setIndustriesAnchorEl(event.currentTarget);
  };

  const handleIndustriesClose = () => {
    setIndustriesAnchorEl(null);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppBar position="relative" sx={{ bgcolor: "#ffffff", color: "#1976d2", boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
              <img src={logo} alt="logo" width={85} />
              <Typography variant="h6" color="#1976d2" noWrap sx={{ ml: 1, fontWeight: 'bold' }}>
                Scherstellen Technologie
              </Typography>
            </Link>
          </Box>
          
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button 
              component={Link} 
              to="/" 
              color="inherit"
              sx={{ 
                color: location.pathname === '/' ? '#1976d2' : '#666',
                fontWeight: location.pathname === '/' ? 'bold' : 'normal',
                px: 2,
                py: 1,
                borderRadius: 2,
                fontSize: '0.9rem',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              Home
            </Button>
            
            <Button 
              onClick={handleServicesClick}
              color="inherit"
              sx={{ 
                color: (location.pathname.startsWith('/applications') || 
                       location.pathname === '/data-ai' || 
                       location.pathname === '/cloud' || 
                       location.pathname === '/digital-workplace' || 
                       location.pathname === '/consulting') ? '#1976d2' : '#666',
                fontWeight: (location.pathname.startsWith('/applications') || 
                           location.pathname === '/data-ai' || 
                           location.pathname === '/cloud' || 
                           location.pathname === '/digital-workplace' || 
                           location.pathname === '/consulting') ? 'bold' : 'normal',
                px: 2,
                py: 1,
                borderRadius: 2,
                fontSize: '0.9rem',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              Services
            </Button>
            
            <Button 
              onClick={handleIndustriesClick}
              color="inherit"
              sx={{ 
                color: (location.pathname.startsWith('/industries')) ? '#1976d2' : '#666',
                fontWeight: (location.pathname.startsWith('/industries')) ? 'bold' : 'normal',
                px: 2,
                py: 1,
                borderRadius: 2,
                fontSize: '0.9rem',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              Industries
            </Button>
            
            <Menu
              anchorEl={servicesAnchorEl}
              open={openServices}
              onClose={handleServicesClose}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 200,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  borderRadius: 2
                }
              }}
            >
              <MenuItem 
                component={Link} 
                to="/applications" 
                onClick={handleServicesClose}
                sx={{
                  color: location.pathname.startsWith('/applications') ? '#1976d2' : '#333',
                  fontWeight: location.pathname.startsWith('/applications') ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Applications
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/data-ai" 
                onClick={handleServicesClose}
                sx={{
                  color: location.pathname === '/data-ai' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/data-ai' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Data & AI
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/cloud" 
                onClick={handleServicesClose}
                sx={{
                  color: location.pathname === '/cloud' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/cloud' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Cloud
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/digital-workplace" 
                onClick={handleServicesClose}
                sx={{
                  color: location.pathname === '/digital-workplace' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/digital-workplace' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Digital Workplace
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/consulting" 
                onClick={handleServicesClose}
                sx={{
                  color: location.pathname === '/consulting' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/consulting' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Consulting
              </MenuItem>
            </Menu>
            
            <Menu
              anchorEl={industriesAnchorEl}
              open={openIndustries}
              onClose={handleIndustriesClose}
              PaperProps={{
                sx: {
                  mt: 1,
                  minWidth: 250,
                  boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                  borderRadius: 2
                }
              }}
            >
              <MenuItem 
                component={Link} 
                to="/industries" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries' ? 'bold' : 'bold',
                  borderBottom: '1px solid #e0e0e0',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                View All Industries
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/insurance" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/insurance' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/insurance' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Insurance
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/automotive" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/automotive' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/automotive' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Automotive
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/manufacturing" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/manufacturing' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/manufacturing' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Manufacturing
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/retail" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/retail' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/retail' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Retail
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/communication-and-media" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/communication-and-media' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/communication-and-media' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Communication & Media
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/travel-transportation" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/travel-transportation' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/travel-transportation' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Travel & Transportation
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/utilities" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/utilities' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/utilities' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Utilities
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/healthcare" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/healthcare' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/healthcare' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Healthcare
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/banking-and-financial-markets" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/banking-and-financial-markets' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/banking-and-financial-markets' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Banking & Financial Markets
              </MenuItem>
              <MenuItem 
                component={Link} 
                to="/industries/chemical-oil-gas" 
                onClick={handleIndustriesClose}
                sx={{
                  color: location.pathname === '/industries/chemical-oil-gas' ? '#1976d2' : '#333',
                  fontWeight: location.pathname === '/industries/chemical-oil-gas' ? 'bold' : 'normal',
                  '&:hover': {
                    bgcolor: 'rgba(25, 118, 210, 0.04)'
                  }
                }}
              >
                Chemical, Oil & Gas
              </MenuItem>
            </Menu>
            
            <Button 
              component={Link} 
              to="/contact-us" 
              color="inherit"
              sx={{ 
                color: location.pathname === '/contact-us' ? '#1976d2' : '#666',
                fontWeight: location.pathname === '/contact-us' ? 'bold' : 'normal',
                px: 2,
                py: 1,
                borderRadius: 2,
                fontSize: '0.9rem',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              Contact Us
            </Button>
            <Button 
              component={Link} 
              to="/about" 
              color="inherit"
              sx={{ 
                color: location.pathname === '/about' ? '#1976d2' : '#666',
                fontWeight: location.pathname === '/about' ? 'bold' : 'normal',
                px: 2,
                py: 1,
                borderRadius: 2,
                fontSize: '0.9rem',
                '&:hover': {
                  bgcolor: 'rgba(25, 118, 210, 0.04)'
                }
              }}
            >
              About
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
      
      <main>
        {children}
      </main>
      
      <StickyFooter />
    </ThemeProvider>
  );
};

export default Layout;
